import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { HeaderCss } from "./styles";

import LogoZest from "../../assets/Images/LogoZest.png";
import SetaVermelha from "../../assets/Images/setaVermelha.svg";

export function Header() {
	const { t, i18n } = useTranslation();
	const [open, setOpen] = useState(false);

	const lang = i18n.language?.startsWith("en") ? "en" : "pt";

	const navItems = useMemo(
		() => [
			{ key: "clients", label: t("header.clients"), href: "#clients" },
			{ key: "jobs", label: t("header.jobs"), href: "#jobs" },
			{ key: "cases", label: t("header.cases"), href: "#cases" },
			{ key: "touch", label: t("header.touch"), href: "#faleConosco" }
		],
		[t]
	);

	function isHomePage() {
		const path = window.location.pathname;
		return path === "/" || path === "";
	}

	function handleLogoClick(e) {
		e.preventDefault();
		setOpen(false);

		if (isHomePage()) {
			window.scrollTo({
				top: 0,
				behavior: "smooth"
			});
			return;
		}

		window.location.href = "/";
	}

	function handleClick(e, href) {
		e.preventDefault();
		setOpen(false);

		const id = href.replace("#", "");

		if (!isHomePage()) {
			window.location.href = `/${href}`;
			return;
		}

		const el = document.getElementById(id);

		if (el) {
			el.scrollIntoView({ behavior: "smooth" });
			return;
		}

		window.location.href = `/${href}`;
	}

	async function handleChangeLanguage(lng) {
		await i18n.changeLanguage(lng);
		setOpen(false);
	}

	useEffect(() => {
		document.body.style.overflow = open ? "hidden" : "auto";

		return () => {
			document.body.style.overflow = "auto";
		};
	}, [open]);

	return (
		<HeaderCss>
			<div className="header-inner">
				<a href="/" onClick={handleLogoClick}>
					<img
						src={LogoZest}
						className="logo"
						title={t("header.zestOne")}
						alt={t("header.zestOne")}
					/>
				</a>

				<nav className="nav-desktop barlow-light">
					{navItems.map((item) => (
						<a
							key={item.key}
							href={item.href}
							onClick={(e) => handleClick(e, item.href)}
						>
							{item.label}
							<img src={SetaVermelha} alt="" />
						</a>
					))}
				</nav>

				<div className="right-area">
					<div className="lang-switch">
						<button
							type="button"
							className={`lang-btn ${lang === "pt" ? "active" : ""}`}
							onClick={() => handleChangeLanguage("pt")}
						>
							PT
						</button>

						<button
							type="button"
							className={`lang-btn ${lang === "en" ? "active" : ""}`}
							onClick={() => handleChangeLanguage("en")}
						>
							EN
						</button>
					</div>

					<button
						className={`hamburger ${open ? "open" : ""}`}
						onClick={() => setOpen((v) => !v)}
						aria-label="Menu"
						aria-expanded={open}
					>
						<span></span>
						<span></span>
						<span></span>
					</button>
				</div>
			</div>

			<div className={`mobile-menu ${open ? "show" : ""}`}>
				{navItems.map((item) => (
					<a
						key={item.key}
						href={item.href}
						onClick={(e) => handleClick(e, item.href)}
					>
						{item.label}
						<img src={SetaVermelha} alt="" />
					</a>
				))}

				<div className="mobile-lang">
					<button
						type="button"
						className={`lang-btn ${lang === "pt" ? "active" : ""}`}
						onClick={() => handleChangeLanguage("pt")}
					>
						PT
					</button>

					<span className="lang-sep">|</span>

					<button
						type="button"
						className={`lang-btn ${lang === "en" ? "active" : ""}`}
						onClick={() => handleChangeLanguage("en")}
					>
						EN
					</button>
				</div>
			</div>
		</HeaderCss>
	);
}